import { render } from "./vertical_event_list.vue?vue&type=template&id=1d9cbb69"
import script from "./vertical_event_list.vue?vue&type=script&lang=js"
export * from "./vertical_event_list.vue?vue&type=script&lang=js"

import "./vertical_event_list.vue?vue&type=style&index=0&id=1d9cbb69&lang=scss"

import exportComponent from "/tmp/build_0d900136/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__